// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"ehe67","disabled_link":"t8qf5","disabledLink":"t8qf5"};